import { z } from 'zod';

export const formDataConexaoSchema = z.object({
  TITULO: z.string().min(1, 'Nome da iniciativa é obrigatório').max(250, 'Máximo de 250 caracteres'),
  BLOCO: z.string().min(1, 'Bloco do Conexão é obrigatório'),
  INDICADOR_NOME: z.string().min(1, 'Indicador é obrigatório'),
  inicioEntrega: z.string().min(1, 'Data de início é obrigatória'),
  conclusaoEntrega: z.string().min(1, 'Data de conclusão é obrigatória'),
  GESTOR_ATUAL_NOME: z.string().min(1, 'Gestor da Super Estadual é obrigatório'),
  DESCRICAO: z.string().min(1, 'Descrição é obrigatória').max(2000, 'Máximo de 2000 caracteres'),
  RESULTADO: z.string().min(1, 'Resultado é obrigatório').max(2000, 'Máximo de 2000 caracteres'),
}).refine((data) => {
  if (data.inicioEntrega) {
    const inicio = new Date(data.inicioEntrega);
    return inicio.getFullYear() === 2025;
  }
  return true;
}, {
  message: 'A data de início deve ser do ano de 2025',
  path: ['inicioEntrega'],
}).refine((data) => {
  if (data.conclusaoEntrega) {
    const conclusao = new Date(data.conclusaoEntrega);
    return conclusao.getFullYear() === 2025;
  }
  return true;
}, {
  message: 'A data de conclusão deve ser do ano de 2025',
  path: ['conclusaoEntrega'],
}).refine((data) => {
  if (data.inicioEntrega && data.conclusaoEntrega) {
    const inicio = new Date(data.inicioEntrega);
    const conclusao = new Date(data.conclusaoEntrega);
    return inicio < conclusao;
  }
  return true;
}, {
  message: 'A data de início deve ser anterior à data de conclusão',
  path: ['conclusaoEntrega'],
});

export type FormDataConexaoType = z.infer<typeof formDataConexaoSchema>;
